export default () => ({
  transactions: []
})



// WEBPACK FOOTER //
// ./src/store/modules/billing/state.js